module.exports = __webpack_public_path__ + "static/img/header.f03a2f7c.png";